import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { AuthProvider } from './src/contexts/AuthContext';
import { ChatProvider } from './src/contexts/ChatContext';
import AppNavigator from './src/navigation/AppNavigator';
import FirstRunGuide from './src/screens/FirstRunGuide';
import BusyOverlay from './src/screens/BusyOverlay';

export default function App() {
  return (
    <SafeAreaProvider>
      <AuthProvider>
        <ChatProvider>
          <AppNavigator />
          <FirstRunGuide />
          <BusyOverlay />
        </ChatProvider>
      </AuthProvider>
    </SafeAreaProvider>
  );
}
